module.exports = __webpack_public_path__ + "img/KARIM.f75e210c.png";